import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const NoItemMessage = (props) => {
    const { noItemMessage, className } = props;
    if (!noItemMessage) {
        return null;
    }
    return (_jsx("ul", Object.assign({ className: className, role: 'menu' }, { children: _jsx("li", Object.assign({ className: 'no-item-message disabled', role: 'presentation' }, { children: _jsx("a", Object.assign({ role: 'menuitem' }, { children: _jsx("i", { children: noItemMessage }) })) })) })));
};
export default NoItemMessage;
